import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const productService = {
  /**
   * Get all products organized by collection for the landing page
   */
  async getLandingPageProducts() {
    try {
      const response = await axios.get(`${API}/products/landing-page`);
      return response.data;
    } catch (error) {
      console.error('Error fetching landing page products:', error);
      throw error;
    }
  },

  /**
   * Get all products from the store
   */
  async getAllProducts(limit = 100) {
    try {
      const response = await axios.get(`${API}/products/all`, {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching all products:', error);
      throw error;
    }
  },

  /**
   * Get products from a specific collection
   */
  async getProductsByCollection(collectionHandle, limit = 20) {
    try {
      const response = await axios.get(`${API}/products/collection/${collectionHandle}`, {
        params: { limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching collection products:', error);
      throw error;
    }
  },

  /**
   * Get a single product by its handle (full images + variants)
   */
  async getProductByHandle(handle) {
    try {
      const response = await axios.get(`${API}/products/handle/${handle}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product by handle:', error);
      throw error;
    }
  },

  /**
   * Search products by title
   */
  async searchProducts(query, limit = 20) {
    try {
      const response = await axios.get(`${API}/products/search`, {
        params: { q: query, limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  }
};

export default productService;
